<template>
  <el-dialog :visible="dialogVisible" width="378px" append-to-body>
    <template #title>
      <div class="title">删除药品</div>
    </template>
    <template #default>
      <span>是否确认删除该药品</span>
    </template>
    <template #footer>
      <el-button class="btn cancel" @click="cancel">取 消</el-button>
      <el-button class="btn" type="primary" @click="submit">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'drugRemoveModal',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submit() {
      this.$emit('submit');
      this.$emit('close');
    },
    cancel() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  display: flex;
  justify-content: center;
  padding: 24px 0 0 0;
  font-size: 18px;
  font-weight: 600;
  color: #242424;
}

/deep/.el-dialog__body {
  display: flex;
  justify-content: center;
  padding: 14px 20px 24px 20px;
  font-size: 14px;
  color: #242424;
}

/deep/.el-dialog__footer {
  display: flex;
  justify-content: center;
  padding: 0 0 24px 0;

  .btn {
    width: 132px;

    &.cancel {
      background: #fff;
      border: 1px solid #dcdfe6;
    }
  }
}
</style>
